import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Download } from "lucide-react";
import { FRAMEWORKS, EVIDENCE_ITEMS, GOV_DISCLAIMER_FRAMEWORK } from "../../governance/govData";
import { savePdf } from "../../governance/govPdf";
import { useGov } from "../../governance/GovContext";
import { Button } from "../ui/button";

export default function FrameworkExplorer() {
  const names = Object.keys(FRAMEWORKS);
  const { framework, setFramework } = useGov();
  const [active, setActive] = useState(names.includes(framework) ? framework : names[0]);
  const rows = FRAMEWORKS[active];
  useEffect(() => { setFramework(active); }, [active, setFramework]);

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {names.map((n) => (
          <button key={n} onClick={() => setActive(n)} className={`px-3.5 py-2 rounded-lg text-sm border transition-colors ${active === n ? "border-primary/40 bg-primary/12 text-foreground" : "border-white/10 text-muted-foreground hover:text-foreground hover:bg-white/5"}`}>{n}</button>
        ))}
      </div>

      <div className="mt-6 space-y-4">
        {rows.map((r, i) => (
          <div key={i} className="rounded-lg border border-white/10 bg-navy-900/60 p-5 grid lg:grid-cols-3 gap-5">
            <div><p className="text-xs uppercase tracking-wide text-muted-foreground">Theme</p><p className="mt-1 text-sm font-semibold text-foreground">{r.theme}</p></div>
            <div><p className="text-xs uppercase tracking-wide text-muted-foreground">Operational question</p><p className="mt-1 text-sm text-muted-foreground">{r.question}</p></div>
            <div><p className="text-xs uppercase tracking-wide text-primary">norse3 control</p><p className="mt-1 text-sm text-foreground">{r.control}</p></div>
          </div>
        ))}
      </div>

      {/* Control map */}
      <div className="mt-6 rounded-lg border border-white/10 bg-navy-900/60 p-6">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">Control map</p>
        <div className="mt-3 flex flex-wrap items-center gap-2 text-sm">
          {[active, "Requirement theme", "Policy", "Action", "Evidence"].map((n, i, arr) => (
            <React.Fragment key={n}>
              <span className="rounded-lg border border-white/12 bg-white/[0.03] px-3 py-1.5 text-foreground">{n}</span>
              {i < arr.length - 1 && <ArrowRight className="h-4 w-4 text-primary/60" />}
            </React.Fragment>
          ))}
        </div>
        <div className="mt-4">
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Evidence created</p>
          <div className="mt-2 flex flex-wrap gap-2">{EVIDENCE_ITEMS.map((e) => <span key={e} className="rounded-full border border-signal-green/25 bg-signal-green/10 px-3 py-1 text-xs text-signal-green">{e}</span>)}</div>
        </div>
      </div>

      <p className="mt-4 text-xs text-muted-foreground/80">{GOV_DISCLAIMER_FRAMEWORK}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90"><Link to="/book-a-demo">Book a norse3 walkthrough <ArrowRight className="ml-1.5 h-4 w-4" /></Link></Button>
        <Button variant="outline" onClick={() => savePdf.framework(active, rows)} data-testid="framework-download-pdf" className="border-white/15 bg-transparent hover:bg-white/5 text-foreground"><Download className="mr-1.5 h-4 w-4" /> Download PDF</Button>
      </div>
    </div>
  );
}
